import { InjectionToken } from '@angular/core';
import { Label } from '../entities/label.model';

export const LABEL_SERVICE = new InjectionToken<LabelRepository>('LABEL_SERVICE');
export interface LabelRepository {
  fetchByUuid(uuids: string[]): Promise<Label[]>;
}
